<template>
  <div class="header">
    <!-- 折叠按钮 -->
    <div class="collapse-btn" @click="collapseChage">
      <i v-if="!collapse" class="el-icon-s-fold"></i>
      <i v-else class="el-icon-s-unfold"></i>
    </div>
    <img class="logo display-middle" @click="$router.go(0)" :src="require('$merchantAsserts/images/vipay_logo.png')"
         alt="merchant_web_log"/>
    <div class="header_flex">
      <div class="business_name" v-text="`${$t('store.merchant')}： ${merchant}`"/>
      <!--      门店下拉框-->
      <div class="store" v-if="storeList.length>1">
        {{ $t('store.store') }}：
        <el-select size="mini" v-model="name" @change="handleChangeStore">
          <template #prefix>
            <i class="el-icon-s-shop"></i>
          </template>
          <el-option v-for="item in storeList"
                     :key="item.storeNo"
                     :value="item.storeNo"
                     :label="$util.lang(item.storeName)">
            {{ $util.lang(item.storeName) }}
          </el-option>
        </el-select>
      </div>
      <div v-else class="add_diot">
        {{ $t('store.store') }}：
        <el-tooltip
          class="item"
          effect="dark"
          :content="$util.lang(storeName)"
          placement="top-start">
          <span style="margin-left: 10px;">{{ $util.lang(storeName) }}</span>
        </el-tooltip>
      </div>
      <!--      营业状态-->
      <div class="isRun">
        <el-select size="mini"
                   :disabled="auth"
                   @change="changeStoreStatu"
                   v-model="isOpen">
          <el-option
            v-for="item in storeStatus"
            :value="item.code"
            :disabled="item.code==='M003'"
            :label="item.message"
            :key="item.code">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="header-right">
      <div class="header-user-con">
        <!-- 消息中心 -->
        <div class="btn-bell">
          <el-switch v-model="isOpenMessagePush"
                     active-color="rgba(255, 107, 13, 1)"
                     :active-text="$t('store.pushMessage')">
          </el-switch>
        </div>
        <div class="show_type">
          <div class="box">
            {{ userType }}
          </div>
        </div>
        <!-- 用户名下拉菜单 -->
        <el-dropdown class="user-name" trigger="hover" @command="handleCommand">
                    <span class="el-dropdown-link">
                        {{ loginName }}
                        <i class="el-icon-caret-bottom"></i>
                    </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item divided command="logOut">{{ $t('login.logout') }}</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <!--          切换语言-->
        <el-popover placement="bottom">
          <template #reference>
            <a class="lan">
              <el-avatar size="medium" class="avatar rotate">{{ lang_func[lang] }}</el-avatar>
            </a>
          </template>
          <div @click="handleChange(item.value)"
               v-for="item in languageList"
               :key="item.id" class="tips"
               :class="{active: item.value == lang}">
            {{ lang_func[item.value] }}
          </div>
        </el-popover>

        <el-popover popper-class="pope" placement="bottom">
          <template #reference>
            <a class="lan">
              <el-avatar size="medium" class="primary rotate">{{ $t('login.help') }}</el-avatar>
            </a>
          </template>
          <div class="center">{{ $t('login.contactCustomer') }}</div>
          <div class="content_info">
            <div>Callcard</div>
            <copy-text style="align-items: center;display: inline-flex" copyText="095809809"/>
            <div>Smart</div>
            <copy-text style="align-items: center;display: inline-flex" copyText="0965550888"/>
            <div>metfone</div>
            <copy-text style="align-items: center;display: inline-flex" copyText="0314500888"/>
          </div>
        </el-popover>
      </div>
    </div>
        <!-- 异常营业弹窗 -->
    <el-dialog
      :modal="true"
      :close-on-click-modal="false"
      :show-close="false"
      :title="$t('store.submitFail')"
      :visible.sync="dialogVisible"
      width="400px"
      custom-class="tipDialog">
      <span style="line-height: 22px;padding: 0 10px;display: inline-block;">{{ $t('store.submitFailTip')}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{$t('common.confirm')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import CopyText from "$merchantComponent/order/copyText";
import BossSocket from '$merchant/page/index/web-socket/web-socket';
import Store from "$common/utils/store";
import { logout as loginoutApi } from "$merChantApi/boss-web/login/index"
import {
  updateStoreStatus as updateStoreStatusApi
} from "$merChantApi/tw-merchant-boss";

const { mapState } = Vuex

export default {
  components: { CopyText },
  data() {
    return {
      lang_func: {
        zh: '中文',
        en: 'English',
        km: 'កម្ពុជា'
      },
      name: Store.loadObject('storeNo') || '',
      lang: Store.loadObject('locale') || 'zh',
      languageList: [
        {
          value: 'zh',
          id: 1,
          name: '中文'
        },
        {
          value: 'en',
          id: 2,
          name: 'En'
        },
        {
          value: 'km',
          id: 3,
          name: 'km'
        }
      ],
      storeName: Store.loadObject('storeName'),
      userType: Store.loadObject('operator_type') == 'master' ? this.$t('store.merchant') : this.$t('store.store'),
      isOpenMessagePush: false,
      dialogVisible: false,
    }
  },
  computed: {
    ...mapState({
      storeList: (state) => state.common.storeList,
      merchant: (state) => $vm.$util.lang(state.common.merchant),
      collapse: (state) => state.collapse,
      storeStatus: (state, getter) => getter.enumStateArr('takeaway-merchant', 'storeStatus')
    }),
    loginName() {
      return Store.loadObject('realLoginName')
    },
    auth() {
      return Store.loadObject('prepareStatus') !== 'S001'
    },
    isOpen: {
      get() {
        return this.$store.state.common.businessStatus
      },
      set(val) {
        this.$store.commit('SET_BUSINESS_STATE', { storeStatus: val })
        Store.saveObject('businessStatus', val)
      }
    }
  },
  watch: {
    isOpenMessagePush(val) {
      Store.saveObject('isNotification', !!val);
      //  是否启用消息推送，取决于变量判断和对象判断
      if (!!val && !Vue.prototype.$socket && process.env.NODE_ENV !== 'development') {
        Vue.prototype.$socket = new BossSocket();
      }
    }
  },
  async mounted() {
    const res = await this.$store.dispatch('get_store_list')
    this.$store.commit('GET_STORE_lISTS', res)
    if (document.body.clientWidth < 1500) {
      this.collapseChage()
    }
    this.$nextTick(() => {
      const __isNotification = Store.loadObject('isNotification')
      if ([true, false].indexOf(__isNotification) === -1) {
        this.isOpenMessagePush = true;
      } else {
        this.isOpenMessagePush = __isNotification;
      }
    });
  },
  methods: {
    // 切换门店
    async handleChangeStore(v) {
      const res = this.storeList.find(i => i.storeNo == v)
      if (res) {
        const { status = '', storeStatus = '' } = res
        Store.saveObject('prepareStatus', status)
        Store.saveObject('businessStatus', storeStatus)
        Store.saveObject('storeNo', v)
      }
      window.location.reload()
    },
    // 切换门店状态
    changeStoreStatu(storeStatus) {
      const _this = this
      if (storeStatus === 'M002') {
        this.$confirm(_this.$t('store.switchBusinessStatus'), _this.$t('common.prompt'), {
          confirmButtonText: _this.$t('common.confirm'),
          cancelButtonText: _this.$t('common.cancel'),
          type: 'warning'
        }).then(async () => {
          const obj = {
            storeNo: Store.loadObject('storeNo'),
            storeStatus
          }
          await updateStoreStatusApi(obj, {
            success: res => {
              this.isOpen = 'M002'
              this.$message({
                type: 'success',
                message: _this.$t('common.operatedSuccess')
              })
            }
          })
        }).catch(() => {
          this.isOpen = 'M001'
          this.$message({
            type: 'info',
            message: _this.$t('common.cancelOperate')
          })
        })
      } else if (storeStatus === 'M001') {
        updateStoreStatusApi({storeNo: Store.loadObject('storeNo'), storeStatus}, {
          success: res => {
            this.isOpen = 'M001'
            this.$message({
              type: 'success',
              message: _this.$t('common.operatedSuccess')
            })
          },
          fail: (err) => {
            this.isOpen = 'M002'
            if(err.rspCd + '' === "ME089"){
                _this.dialogVisible = true
            }
          }
        })
      } else {
      }
    },
    // 切换语言
    handleChange(lang) {
      Store.saveObject('locale', lang)
      this.$i18n.locale = lang.value
      window.location.reload()
    },
    // 退出登录 清空localStore 保留国际化和登录页信息
    async handleCommand(v) {
      try {
        const loginName = Store.loadObject('realLoginName')
        const {rspCd} = await loginoutApi({loginName})
        if (rspCd + '' === '00000') {
          const loginNames = Store.loadObject('loginName')
          const isRemember = Store.loadObject('isRemerber')
          if (isRemember) {
            Store.saveObject('loginName', loginNames)
            Store.saveObject('isRemerber', isRemember)
          }
          const lang = Store.loadObject('locale')
          localStorage.clear()
          Store.saveObject('locale', lang)
          await this.$router.push('/login')
        }
      } catch (e) {
        console.log('logout error!,please try again !', e)
      }
    },
    collapseChage() {
      this.$store.commit('handleCollapse', !this.collapse)
    }
  }
}
</script>
<style scoped>
.header {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  font-size: 22px;
  color: #fff;
  height: 4rem;
  background-color: #001020;
}

.add_diot {
  line-height: 47px;
  color: #fffcfc;
  cursor: pointer;
  max-width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis
}

.collapse-btn {
  float: left;
  padding: 0 21px;
  cursor: pointer;
  line-height: 4rem;
}

.collapse-btn:hover {
  background: rgb(40, 52, 70);
}

.header .logo {
  width: 7rem;
  line-height: 4rem;
  height: 4rem;
  display: inline-block;
}

.header-right {
  position: absolute;
  right: 15px;
  z-index: 22;
  top: 1px;
}

@media screen and (max-width: 1200px) {
  .header-right .btn-bell {
    display: none;
  }

  .show_type {
    display: none;
  }
}

.header-user-con {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  height: 4rem;
  align-items: center;
}

.header-user-con div {
  margin: 5px 6px;
}

.btn-fullscreen {
  transform: rotate(45deg);
  margin-right: 5px;
  font-size: 24px;
}

.btn-bell,
.btn-fullscreen {
  position: relative;
  width: 175px;
  height: 30px;
  text-align: center;
  border-radius: 15px;
  color: #fff;
}

.btn-bell-badge {
  position: absolute;
  right: 0;
  top: -2px;
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: #f56c6c;
  color: #fff;
}

.btn-bell .el-icon-bell {
  color: #fff;
}

>>> .btn-bell .el-switch .el-switch__label {
  color: #eee
}

>>> .btn-bell .el-switch .el-switch__label.is-active {
  color: #fff
}

.user-avator {
  margin-left: 20px;
}

.user-avator img {
  display: block;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.el-dropdown-link {
  color: #fff;
  cursor: pointer;
}

.lan {
  cursor: pointer;
  margin-top: 3px;
  margin-left: 10px;
}

.el-dropdown-menu__item {
  text-align: center;
}

.header_flex {
  height: 100%;
  overflow: hidden;
  display: inline-flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
}

.header_flex div {
  font-family: "PingFangSC-Regular, sans-serif";
  margin: 0px 10px;
  font-size: 14px;

}

.header_flex .business_name {
  justify-content: center;
  align-items: center;
}

.store .el-select {
  width: 175px;
  display: inline-block;
}

.isRun .el-select {
  width: 100px;
  display: inline-block;
}

.s-r {
  width: 70px;
}

.avatar {
  background: #ccc;
}

.tips {
  cursor: pointer;
  padding: 5px;
}

.tips:hover {
  background: #f8f8f9;
}

.active {
  color: #f39322
}

.center {
  text-align: center;
  margin-top: 10px;
  margin-left: -5px;
}

.content_info {
  font-size: 14px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
}

.content_info div {
  margin: 10px 0px;
  width: 40%;
}

.box {
  box-sizing: content-box !important;
  text-align: center;
  height: 24px;
  border-radius: 4px;
  /*background: #FF6B0D;*/
  font-size: 14px;
  line-height: 24px;
}

.show_type {
  margin: 5px 10px 5px 0px !important;;
}

</style>
<style>
.pope {
  width: 200px !important;
  padding: 0px !important;
}
</style>
